module.exports = __webpack_public_path__ + "img/template23.771111db.png";